
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 22,
  viewBox: "0 0 18 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.54 0a8.54 8.54 0 0 1 8.54 8.54c0 6.53-8.54 13.06-8.54 13.06l-.3-.238C6.726 20.137 0 14.363 0 8.54A8.54 8.54 0 0 1 8.54 0zm0 1.152A7.388 7.388 0 0 0 1.152 8.54c0 2.529 1.483 5.367 3.986 8.233.9 1.03 1.866 1.989 2.833 2.848l.392.344.175.148.37-.318.199-.177a32.415 32.415 0 0 0 2.834-2.856c2.503-2.871 3.986-5.707 3.986-8.222A7.388 7.388 0 0 0 8.54 1.152z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.54 5.023a3.517 3.517 0 1 1-.001 7.033 3.517 3.517 0 0 1 .001-7.033zm0 1.152a2.365 2.365 0 1 0 0 4.73 2.365 2.365 0 0 0 0-4.73z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"22\" viewBox=\"0 0 18 22\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M8.54 0c4.716 0 8.54 3.823 8.54 8.54 0 6.53-8.54 13.06-8.54 13.06l-.3-.238C6.726 20.137 0 14.363 0 8.54 0 3.823 3.823 0 8.54 0zm0 1.152c-4.08 0-7.388 3.308-7.388 7.388 0 2.529 1.483 5.367 3.986 8.233.9 1.03 1.866 1.989 2.833 2.848l.392.344.175.148.37-.318.199-.177c.967-.863 1.934-1.824 2.834-2.856 2.503-2.871 3.986-5.707 3.986-8.222 0-4.08-3.307-7.388-7.387-7.388z\" transform=\"translate(-325 -397) translate(17 339) translate(308 58)\"/>\r\n                    <path d=\"M8.54 5.023c1.942 0 3.516 1.575 3.516 3.517s-1.574 3.516-3.516 3.516-3.517-1.574-3.517-3.516S6.598 5.023 8.54 5.023zm0 1.152c-1.306 0-2.365 1.059-2.365 2.365 0 1.305 1.059 2.364 2.365 2.364 1.305 0 2.364-1.059 2.364-2.364 0-1.306-1.059-2.365-2.364-2.365z\" transform=\"translate(-325 -397) translate(17 339) translate(308 58)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/location.1c7c776531b86505891803a18a0d75d5.svg"),
        {
          React: SvgLocation,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      